import { render, staticRenderFns } from "./PushConf.vue?vue&type=template&id=398b4a27&scoped=true&"
import script from "./PushConf.vue?vue&type=script&lang=js&"
export * from "./PushConf.vue?vue&type=script&lang=js&"
import style0 from "./PushConf.vue?vue&type=style&index=0&id=398b4a27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b4a27",
  null
  
)

export default component.exports